import React from 'react';
import {Button} from "antd";

export function AuthFooterLinkNewMobileSection({myMobile, changeMyState}) {
    return (
        <div className="mt-4 text-center text-sm">
            شماره{" "}
            <span className={'font-bold mx-1 ltr inline-block'}
                  style={{direction: "ltr", display: "inline-block"}}>
                                                   {myMobile}</span>

            {' '}
            متعلق به شما نیست؟
            <Button type={'link'} className={''} onClick={() => changeMyState('check')}>

                شروع با موبایل جدید

            </Button>
        </div>
    );
}
